import styled from "styled-components"

export const HeaderContainer = styled.div`
    display: flex;
    margin: 40px auto;
    max-width: 900px;
    align-items: center;
    padding-top: 70px;
    padding: 20px; 
    
    
    
    @media (max-width: 1000px) { 
        padding: 0 70px;
    }
    

    @media (max-width: 815px) { 
        display: block;
        margin-top: 20px;
    }
    
    @media (max-width: 700px) { 
        display: block;
        margin-top: 20px;
    }

    
    @media (max-width: 400px) {
        margin-top: 0px; 
        padding: 0px 25px;
    }

    
`;

export const HeaderTitle = styled.h1`
    color: #e0e0e0;
    font-size: 26px;
    
    @media (max-width: 815px) {
        display: inline;
    }

    @media (max-width: 400px) {
        font-size: 17px;
    }
`;


export const HeaderNumber = styled.h1`
    font-size: 23px;
    font-weight: normal;
    margin-right: 10px;
    color: #BB86FC;
    
    @media (max-width: 815px) {
        display: inline;
    }
    @media (max-width: 400px) {
        font-size: 15px;
    }
`;

export const Container = styled.div`
    display: block;
    margin: 40px auto;
    font-size: 17px;
    max-width: 900px;
    color: #969696;

`;

// css for the project item one - left snapshot 

export const ItemContainer = styled.div`
    display: flex;
    margin-bottom: 100px;

`;

export const ItemSnapshotContainer = styled.div`
    max-width: 500px;
    z-index: 1;
    border-radius: 3px;
    border: solid 1px #969696;
    
`;

export const ItemSnapshot = styled.img`
    width: 100%;
    height: auto;
    vertical-align: middle;
`;

export const InfoContainer = styled.div`
    text-align: right;
    margin-left: -50px;
    z-index: 2;

`;

export const FeaturedText = styled.p`
    color: #BB86FC;
    font-size: 12px;
    
`;

export const ItemName = styled.h1`
    font-size: 21px;
    margin-bottom: 15px;
    color: #e0e0e0;

    
`;

export const DescriptionContainer = styled.div`
    background-color: #161616;
    padding: 20px;
    border-radius: 3px;
    max-width: 500px;

    
`;

export const DescriptionText = styled.p`
    font-size: 13px;
`;

export const TechnologiesContainer = styled.div`
    display: flex;
    justify-content: right;
    width: 100%;
    justify-content: flex-end;
`;

export const TechnologiesText = styled.p`
    margin-top: 10px;
    margin-left: 25px;
    display: inline;
    font-size: 12px;
`;

export const LinksContainer = styled.div`
    margin-top: 10px;

`;

export const Link = styled.a`
    font-size: 14px;
    margin-left: 25px;
    color: #BB86FC;
`;



// special css for the project item two - right snapshot 

export const InfoContainerTwo = styled.div`
    text-align: left;
    margin-right: -50px;
    z-index: 2;

    

`;

export const TechnologiesContainerTwo = styled.div`
    display: flex;
    justify-content: left;
    width: 100%;
    justify-content: flex-start;
`;

export const TechnologiesTextTwo = styled.p`
    margin-top: 10px;
    margin-right: 25px;
    display: inline;
    font-size: 12px;
`;


export const LinkTwo = styled.a`
    font-size: 14px;
    margin-right: 25px;
    color: #BB86FC;
`;


// for small screen project css


export const InfoContainerSmall = styled.div`
    text-align: left;
    margin-left: 0;

`;

export const FeaturedTextSmall = styled.p`
    color: #BB86FC;
    font-size: 12px;
    margin-bottom: 15px;
`;

export const ItemNameSmall = styled.h1`
    font-size: 21px;
    color: #e0e0e0;
    margin-bottom: 0;
    display: inline;
`;


export const TechnologiesContainerSmall = styled.div`
    display: flex;
    width: 100%;
    justify-content: left;
    justify-content: flex-start;
    margin-top: 20px;
    flex-wrap: wrap;
`;

export const TechnologiesTextSmall = styled.p`
    margin-top: 10px;
    margin-right: 25px;
    display: inline;
    font-size: 12px;
`;


export const ItemInner = styled.div`
    /* border: solid 1px darkgray; */
    width: 500px;
    border-radius: 3px;
    margin: 0 auto;
    margin-bottom: 10px;
    background-color: #161616;
    padding: 20px;

    
    @media (max-width: 600px) { 
        width: 290px;
        margin: 25px auto;
    }
    
    @media (max-width: 380px) { 
        width: 270px;
        margin: 10px auto;
    }
    
    @media (max-width: 340px) { 
        margin: 10px auto;
        width: 220px;
    }
    
`;


export const DescriptionContainerSmall = styled.div`
    background-color: #161616;
    padding: 20px 0;
    border-radius: 3px;
    max-width: 500px;

    
`;

        

export const ItemSnapshotContainerSmall = styled.div`
    border-radius: 3px;
    text-align: left;
    width: 100%;
`;


export const LinkSmall = styled.a`
    font-size: 20px;
    margin-left: 10px;
    color: #BB86FC;
    display: inline;
`;